export default __webpack_public_path__ + "static/media/DefaultImageUnitCrop.3b26109c.png";